import {
  colorLegacy,
  colorTokens,
  grantedBrandColors,
  lightColors,
  postfixObjKeys,
} from "./legacy/token-colors";

// Re-export legacy for backward compatibility
export { colorTokens, grantedBrandColors, lightColors, postfixObjKeys };

export const colors = {
  // Utility
  transparent: "transparent",

  // System - Surfaces
  backgroundPrimary: "#FAF9F8",
  backgroundSecondary: "#F5F4F1",
  white: "#FFFFFF",

  // System - Text
  primary: "#010222", // Main text color
  secondary: "#7E7C79", // Supporting text
  disabled: "#98938B", // Disabled text

  // System - UI Elements
  stroke: "#EBE7E0", // Borders, dividers
  iconFill: "#D5CFC9", // Icon fills

  navy: "#002160",
  navyDark: "#0E173B",

  positiveDark: "#4E7C23",
  positive: "#DEF5AD",
  positiveLight: "#EFFAD6",

  negativeDark: "#B84A4A",
  negative: "#EB6B6B",
  negativeLight: "#FFEEED",

  warningDark: "#B55007",
  warning: "#FCA92C",
  warningLight: "#FFEFDE",
} as const;

// V2 Design System theme tokens
export const themeTokens = {
  transparent: colors.transparent,

  surfacePrimary: colors.backgroundPrimary,
  surfaceSecondary: colors.backgroundSecondary,
  surfaceWhite: colors.white,

  textPrimary: colors.primary,
  textSecondary: colors.secondary,
  textDisabled: colors.disabled,

  uiStroke: colors.stroke,
  uiIconFill: colors.iconFill,

  brandNavy: colors.navy,
  brandNavyDark: colors.navyDark,

  alertPositive: colors.positive,
  alertPositiveDark: colors.positiveDark,
  alertPositiveLight: colors.positiveLight,

  alertNegative: colors.negative,
  alertNegativeDark: colors.negativeDark,
  alertNegativeLight: colors.negativeLight,

  alertWarning: colors.warning,
  alertWarningDark: colors.warningDark,
  alertWarningLight: colors.warningLight,
} as const;

// Combined export used by tamagui.config.ts
// Includes v2 tokens so they're registered as CSS variables and known to TypeScript
// The legacy theme doesn't use the theme tokens; they're only used via <Theme name="v2">
export const color = {
  ...colorLegacy,
  ...themeTokens,
};
